import React, { useEffect } from 'react';
import { useTrustyActor, useTrustyState } from '../TrustyProvider';
import { trustyConstants as c } from '../../lib/trusty.constants';
import { HoldButton, Odometer } from '../../../../shared/ui';
import css from './TrustyUI.module.css';

export const UIPaused = () => {
    const { send } = useTrustyActor();
    const state = useTrustyState();
    
    const {
        score, 
        timer, 
        streak
    } = state.context;

    useEffect(() => {
        const handleKeyDown = (event) => {
            const key = event.key.toLowerCase();
            if (key === 'p' || key === 'з') {
                send({ type: c.events.RESUME });
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [send]);

    return (
        <div className={css.playingUI} style={{opacity: 0.8}}>
            <div className={css.header}>
                <div className={css.timer}>
                    <span className={css.label}>Час (ПАУЗА):</span>
                    <Odometer number={timer} />
                </div>
                <div className={css.score}>
                    <span className={css.label}>Бали:</span>
                    <Odometer number={score} />
                </div>
            </div>

            <div className={css.streakContainer}>
                <div className={css.streak} style={{animation: 'none', color: '#666'}}>
                    PAUSED - press P to resume
                </div>
            </div>

            <div className={css.controls}>
                <HoldButton 
                    onAction={() => send({ type: c.events.RESUME })} 
                    className={css.actionBtn}
                    style={{width: '100%'}}
                >
                    RESUME
                </HoldButton>
            </div>
        </div>
    );
};
